module.exports = __webpack_public_path__ + "img/login.547a230d.jpg";